import { useWindowSize } from "usehooks-ts";
import { useNavColumn } from "@/app-shell/nav-column-state";

const RAIL = 64;
const FINDINGS_MIN = 280;
const FINDINGS_MAX = 400;
const RECORD = 400;
const GAPS = 16;
const PAGE_MIN = 320;
const PAGE_COMFORTABLE = 640;

/**
 * The findings column and the record each dock only when the finding keeps
 * its width. The nav column is resizable, so a fixed breakpoint is wrong:
 * a wide nav and a docked record will swallow the page.
 */
export const useReviewLayout = (chatOpen = false) => {
  const { width = 0 } = useWindowSize();
  const nav = useNavColumn();
  const navWidth = nav.hidden ? 0 : nav.width.value;
  const spare =
    width - (RAIL + navWidth + FINDINGS_MIN + RECORD + PAGE_COMFORTABLE + GAPS);
  const findingsWidth =
    FINDINGS_MIN + Math.min(FINDINGS_MAX - FINDINGS_MIN, Math.max(0, spare));
  const dockChat = width >= RAIL + navWidth + PAGE_MIN + RECORD + GAPS;
  const chatWidth = chatOpen && dockChat ? RECORD : 0;
  const withColumn =
    RAIL + navWidth + findingsWidth + PAGE_MIN + GAPS + chatWidth;
  // The shell column lives beside the page only at md and above.
  const desktop = width >= 768;
  return {
    findingsWidth,
    dockChat: desktop && dockChat,
    dockColumn: desktop && width >= withColumn,
    dockRecord: desktop && width >= withColumn + RECORD,
  };
};
